import { httpRequest } from "@services/http";
import { SftpKey } from "@models/SftpSettings.model";

export interface CreateSftpKeyPayload {
  body: string;
  label?: string;
}

export class CommandCreateSftpKey {
  async run(organizationId: number, payload: CreateSftpKeyPayload): Promise<SftpKey> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/sftp/${organizationId}/keys`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return SftpKey.fromJson(response);
  }
}
